import Charts from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { StockMarketHeading } from "../../../Constant";
import { CANDLESTICK_CHART_DATA } from "../../../Data/Widgets/ChartWidgets";

const StockMarket = () => {
  return (
    <Col sm="12" className="box-col-12">
      <div className="donut-chart-widget">
        <Card>
          <CommonCardHeader title={StockMarketHeading} className="border-bottom-1"/>
          <CardBody>
            <div id="chart-widget13">
              <Charts options={CANDLESTICK_CHART_DATA} series={CANDLESTICK_CHART_DATA.series} height={450} type="line"/>
            </div>
          </CardBody>
        </Card>
      </div>
    </Col>
  );
};

export default StockMarket;
